import Range from './Range';

export default Range;
